document.addEventListener('DOMContentLoaded', function () {
  const videoModal = document.querySelector('.js-videoModal');

  if (!videoModal) {
    return;
  }

  const body = document.querySelector('body');
  const videoItems = document.querySelectorAll('.js-videoItem');
  const modalHeader = videoModal.querySelector('.js-modalHeader');
  const modalBody = videoModal.querySelector('.js-modalBody');
  const videoModalClose = videoModal.querySelector('.js-videoModalClose');
  const categoryElement = videoModal.querySelector('.js-modalCategory');
  const titleElement = videoModal.querySelector('.js-modalTitle');
  const machineTemplate = videoModal.querySelector('.js-modalMachineTemplate');
  const machineList = videoModal.querySelector('.js-modalMachineList');
  const noMachine = videoModal.querySelector('.js-modalNoMachine');
  const flowTemplate = videoModal.querySelector('.js-modalFlowTemplate');
  const flowList = videoModal.querySelector('.js-modalFlowList');
  const noFlow = videoModal.querySelector('.js-modalNoFlow');

  if (videoItems.length === 0) {
    return;
  }

  // Splideによりis-activeクラスが追加される変更の監視
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const item = mutation.target;
        if (item.classList.contains('is-active')) {
          updateModalContent(item);
        }
      }
    });
  });

  videoItems.forEach((item) => {
    const videoModalOpen = item.querySelector('.js-videoModalOpen');

    videoModalOpen.addEventListener('click', function () {
      // モーダルを開く
      videoModal.classList.add('is-open');
      body.classList.add('is-fixed');

      // header分の高さを、bodyのpadding-bottomに設定
      const headerHeight = modalHeader.offsetHeight;
      modalBody.style.paddingBottom = `${headerHeight}px`;
    });

    observer.observe(item, { attributes: true });

    // 既にis-activeクラスがある場合は、モーダルの内容を更新
    if (item.classList.contains('is-active')) {
      updateModalContent(item);
    }
  });

  // モーダルの内容を更新
  function updateModalContent(item) {
    // カテゴリ・タイトルを設定
    const category = item.dataset.movieCategory;
    const number = item.dataset.movieNumber;
    const title = item.dataset.movieTitle;

    categoryElement.textContent = category;
    titleElement.textContent = number + ' ' + title;

    // 使用機器を表示
    const machineLoopCount = item.dataset.movieMachineCount;

    machineList.innerHTML = '';

    if (!machineLoopCount) {
      noMachine.classList.add('is-show');
    } else {
      noMachine.classList.remove('is-show');
      for (let i = 0; i < machineLoopCount; i++) {
        const machineImage = item.dataset[`movieMachineImage-${i}`];
        const machineTitle = item.dataset[`movieMachineTitle-${i}`];

        const machineItem = machineTemplate.content.cloneNode(true);
        const imgElement = machineItem.querySelector('.js-modalMachineImage');

        if (machineImage) {
          imgElement.innerHTML = `<img src="${machineImage}" alt="">`;
        }

        machineItem.querySelector('.js-modalMachineTitle').textContent = machineTitle;

        machineList.appendChild(machineItem);
      }
    }

    // 作業手順を表示
    const flowLoopCount = item.dataset.movieFlowCount;

    flowList.innerHTML = '';

    if (!flowLoopCount) {
      noFlow.classList.add('is-show');
    } else {
      noFlow.classList.remove('is-show');
      for (let i = 0; i < flowLoopCount; i++) {
        const flowImage = item.dataset[`movieFlowImage-${i}`];
        const flowText = item.dataset[`movieFlowText-${i}`];

        const flowItem = flowTemplate.content.cloneNode(true);

        flowItem.querySelector('.js-modalFlowNumber').textContent = i + 1;

        if (flowImage) {
          flowItem.querySelector('.js-modalFlowImage').innerHTML =
            `<img src="${flowImage}" alt="">`;
        } else {
          flowItem.querySelector('.js-modalFlowImage').remove();
        }

        flowItem.querySelector('.js-modalFlowText').innerHTML = flowText;

        flowList.appendChild(flowItem);
      }
    }
  }

  videoModalClose.addEventListener('click', function () {
    videoModal.classList.remove('is-open');
    body.classList.remove('is-fixed');
  });
});
